import React, { useEffect, useState } from 'react';
import { FaPlus, FaPrint } from 'react-icons/fa';
import MainView from '../../../components/MainView';

import NavHistory from '../../../components/NavHistory'
import bankAccountServices from '../../../services/admFin/bankAccountServices';
import BankAccountCard from './BankAccountCard';
import BankAccountPopUp from '../Records/BankAccountsCard/BankAccountPopUp'


import './styles.css'
import SearchBar from '../../../components/SearchBar';
import checkDeviceType from '../../../checkDeviceType';
import ActivityIndicator from '../../../components/ActivityIndicator';
import PopupReports from '../../../components/PopupReports';
import reportServices from '../../../services/reportServices';
import BankAccountTransfersCard from './BankAccountTransfersCard';


export default function BankAccountsPage(props) {
    const [bankAccounts, setBankAccounts] = useState([]);
    const [bankAccountsShow, setBankAccountsShow] = useState([]);
    const [visibility, setVisibility] = useState(false);
    const [visibilityTransfer, setVisibilityTransfer] = useState(false);
    const [visibilityReport, setVisibilityReport] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [deviceType, setDeviceType] = useState("");
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        window.addEventListener('resize', () => {
            setDeviceType(checkDeviceType())
        });
        getBankAccounts();
    }, []);

    async function createBankAccount(bankAccount) {
        if (!bankAccount.banco || !bankAccount.agencia || !bankAccount.numero || !bankAccount.tipo || !bankAccount.saldo || bankAccount.moeda === "") {
            alert("Os campos devem estar preenchidos");
            return;
        }
        try {
            const response = await bankAccountServices.postBankAccount(bankAccount.banco, bankAccount.agencia, bankAccount.numero, bankAccount.tipo, bankAccount.moeda,parseFloat(bankAccount.saldo));
            setBankAccounts(oldArray => {
                const temp = [...oldArray];
                temp.push(response.data);
                return temp;
            })
            setVisibility(false);
        } catch (err) {
            alert("Não foi possível criar a conta bancária")
        }
    }

    async function getBankAccounts() {
        setFetching(true);
        try {
            const response = await bankAccountServices.getBankAccounts();
            setBankAccounts(response.data);
        } catch (err) {
            alert(err.message);
        }
        setFetching(false);
    }

    function searchBankAccount(bankName) {
        let bankAccountsTemp = bankAccounts.filter(obj => obj.banco.toLowerCase().includes(bankName.toLowerCase()));
        setBankAccountsShow(bankAccountsTemp);
    }

    function generateReport(fields = null, fileName) {
        console.log(fields);
        try {
            reportServices.generateReportBankAccouts(bankAccounts, `RELATÓRIO DE CONTAS BANCÁRIAS`, fields, fileName);
            return true;
        } catch (err) {
            alert(err.message);
            return false;
        }
    }

    useEffect(() => {
        setBankAccountsShow(bankAccounts);
    }, [bankAccounts]);

    return (
        <MainView
            currentPage='bank_accounts'
            admFinMenu
        >
            <NavHistory navPages={['Contas Bancárias']} />

            <div className='bank-account-page-options'>
                <SearchBar
                    placeholder={deviceType === 'phone' ? "Nome do Banco" : "Digite o nome do Banco"}
                    onChange={(event) => {
                        setSearchText(event.target.value);
                        if (event.target.value === "")
                            setBankAccountsShow(bankAccounts);
                    }}
                    value={searchText}
                    onClick={() => searchBankAccount(searchText)}
                />

                <button className='bank-accounts-page-new-button' onClick={() => setVisibility(true)}>Nova Conta Bancária <FaPlus /></button>
                <BankAccountPopUp
                    visibility={visibility}
                    setVisibility={setVisibility}
                    tittle="Criar Conta Bancária"
                    buttonTittle="Criar"
                    onClick={createBankAccount}
                />

                <button className='bank-accounts-page-transfer-button' onClick={() => setVisibilityTransfer(true)}>Transferências Bancárias</button>
                <BankAccountTransfersCard
                    visibility={visibilityTransfer}
                    setVisibility={setVisibilityTransfer}
                    bankAccounts={bankAccounts}
                    getBankAccounts={getBankAccounts}
                />
                
                <button className='bank-accounts-page-report-button' title="Relatório de contas bancárias" onClick={() => setVisibilityReport(true)}><FaPrint/></button>
                <PopupReports
                    visibility={visibilityReport}
                    setVisibility={setVisibilityReport}
                    tittle="Relatório de Contas Bancárias"
                    fields={reportServices.bankAccountFields}
                    generateReport={generateReport}
                />
            </div>

            <div className='bank-accounts-page-container'>
                {
                    !fetching ?
                        bankAccountsShow.length ?
                            <ul className='bank-accounts-page-list-container'>
                                {
                                    bankAccountsShow.map(bankAccount => {
                                        return (
                                            <BankAccountCard
                                                key={bankAccount.id}
                                                bankAccount={bankAccount}
                                                setBankAccounts={setBankAccounts}
                                            />
                                        )
                                    })
                                }
                            </ul>
                            : []
                        : <ActivityIndicator />
                }
            </div>
        </MainView>
    )
}